"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import BaseControl from "D5Utils/form_fields/BaseControl";

var TextControl =
/*#__PURE__*/
function (_BaseControl) {
  _inherits(TextControl, _BaseControl);

  function TextControl() {
    _classCallCheck(this, TextControl);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextControl).apply(this, arguments));
  }

  _createClass(TextControl, [{
    key: "instance",
    value: function instance() {
      return this.$_element.dxTextBox('instance');
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.$_element.dxTextBox('dispose');
      this.$_element.remove();
    }
  }, {
    key: "render",
    value: function render() {
      this.$_element = this.$_element.dxTextBox(_objectSpread({}, this._buildControlProps()));
    }
  }]);

  return TextControl;
}(BaseControl);

export { TextControl as default };